import React, { useRef } from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip, Stack } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

const UploadQuestionAndScheme = ({ onQuestionPaperUpload, onPaperSchemeUpload }) => {
  const questionInputRef = useRef(null);
  const schemeInputRef = useRef(null);

  const handleFileSelected = (event, callback) => {
    const file = event.target.files?.[0] || null;
    if (file && callback) {
      callback(file);
    }
  };

  return (
    <Stack direction="row" spacing={0} alignItems="center">
      {/* Question Paper Upload (Single PDF) */}
      <input
        type="file"
        ref={questionInputRef}
        accept="application/pdf" // 👉 only PDF
        style={{ display: "none" }}
        onChange={(e) => handleFileSelected(e, onQuestionPaperUpload)}
      />

      <Tooltip title="Upload Question Paper (PDF)">
        <IconButton color="primary" onClick={() => questionInputRef.current?.click()}>
          <UploadIcon />
        </IconButton>
      </Tooltip>

      {/* Paper Scheme Upload (Single PDF) */}
      <input
        type="file"
        ref={schemeInputRef}
        accept="application/pdf" // 👉 only PDF
        style={{ display: "none" }}
        onChange={(e) => handleFileSelected(e, onPaperSchemeUpload)}
      />

      <Tooltip title="Upload Paper Scheme (PDF)">
        <IconButton color="secondary" onClick={() => schemeInputRef.current?.click()}>
          <UploadIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

UploadQuestionAndScheme.propTypes = {
  onQuestionPaperUpload: PropTypes.func.isRequired,
  onPaperSchemeUpload: PropTypes.func.isRequired,
};

export default UploadQuestionAndScheme;
